import { DEFAULT_USER_INFO_STATE } from './useUserInfoStore.js';
import { formatPhoneNumber } from '@usecapsule/react-common';
export const getActions = (set, get) => ({
    resetState: () => {
        set(DEFAULT_USER_INFO_STATE);
    },
    setIdentifier: identifier => {
        set({ identifier });
    },
    setIdentifierType: identifierType => {
        set({ identifierType });
    },
    setCountryCode: countryCode => {
        set({ countryCode });
    },
    getUsername: () => {
        var _a, _b;
        const identifierType = get().identifierType;
        const identifier = get().identifier;
        let username = identifier;
        const isPhone = identifierType === 'phone';
        if (isPhone) {
            const countryCode = ((_b = (_a = get().countryCode) === null || _a === void 0 ? void 0 : _a.split('+')[1]) !== null && _b !== void 0 ? _b : '1');
            username = identifier.length > 2 ? formatPhoneNumber(identifier, countryCode) : '';
        }
        return username;
    },
    setRecoveryShare: recoveryShare => {
        set({ recoveryShare });
    },
});
